import { WhenVisibilityIsImminent } from "@faire/web/ui/VisibilitySensor/WhenVisibilityIsImminent";
import React from "react";
import styled, { keyframes, css } from "styled-components";

interface IProps {
  children?: React.ReactNode | undefined;
  bottomThreshold?: number;
  offset: string;
  fill?: boolean;
  constrainSize?: boolean;
}

export const SlideIn: React.FC<IProps> = ({
  bottomThreshold = 100,
  offset,
  children,
  fill,
  constrainSize,
}) => (
  <WhenVisibilityIsImminent
    bottomThreshold={bottomThreshold}
    customizePlaceholder={<div style={{ opacity: 0 }}>{children}</div>}
  >
    <AnimatedSlideIn
      $offset={offset}
      $fill={fill}
      $constrainSize={constrainSize}
    >
      {children}
    </AnimatedSlideIn>
  </WhenVisibilityIsImminent>
);

const AnimatedSlideIn = styled.div<{
  $offset: string;
  $fill?: boolean;
  $constrainSize?: boolean;
}>`
  position: relative;
  animation: ${(props) => getKeyframes(props.$offset)} 800ms ease-out forwards;

  ${({ $constrainSize }) =>
    $constrainSize
      ? css`
          max-width: 100%;
          max-height: 100%;
        `
      : ""}

  ${({ $fill }) =>
    $fill
      ? css`
          width: 100%;
          height: 100%;
        `
      : ""}
`;

const getKeyframes = (offset: string) => keyframes`
    0% {
      opacity: 0;
      bottom: -${offset};
    }
    100% {
      opacity: 1;
      bottom: 0;
    }
  `;
